'use client';

export { canonicalMarketSet, type ExpectedOutcomeIdentity, isPoolSnapshotUnavailable, type MarketPlatformConfig, type MarketPoolQueryResult, type MarketPoolRow, marketPoolQueryArgs, marketPoolSnapshotFromMarketRow, type OnchainTradeData, type OnchainTradeDataByMarket, onchainTradeDataFromMarketRow, onchainTradeDataFromMarketRows, type PoolSnapshotQueryState } from '@morfi/backend-sdk-v2/client';
import { useMarketPoolQuoteSnapshot, useMarketPoolQuoteSnapshots } from '@morfi/backend-sdk-v2/client';
import { logger } from '@/lib/telemetry/logger';
const warnedProjectionFailures: Set<string> = new Set<string>();
export function useOnchainTradeData(marketAddress, expectedOutcomeCount, expectedOutcomeIdentities, embeddedMarket) {
  const result = useMarketPoolQuoteSnapshot(marketAddress, expectedOutcomeCount, expectedOutcomeIdentities, embeddedMarket);
  reportError(marketAddress ?? "", result.error);
  reportMissingAmmConfig(result.hasMissingAmmConfig === true);
  return result;
}
export function useOnchainTradeDataBatch(requestedMarkets, expected) {
  const result = useMarketPoolQuoteSnapshots(requestedMarkets, expected);
  reportError(requestedMarkets.join(","), result.error);
  reportMissingAmmConfig(result.hasMissingAmmConfig === true);
  return result;
}
function reportError(markets: string, error: Error | null): void {
  if (markets.length === 0 || error === null) return;
  const key = `${markets}:${error.message}`;
  if (warnedProjectionFailures.has(key)) return;
  warnedProjectionFailures.add(key);
  logger.warn('market_pool.market_projection_unavailable', {
    markets,
    error: error.message
  });
}
let warnedMissingAmmConfig = false;
function reportMissingAmmConfig(hasMissingAmmConfig: boolean): void {
  if (!hasMissingAmmConfig || warnedMissingAmmConfig) return;
  warnedMissingAmmConfig = true;
  logger.warn('market_pool.amm_fee_config_missing', {
    reason: 'missing_indexed_cp_swap_context'
  });
}